export default {
  desktopOrMobile: () => (window.screen.width > 768 ? "desktop" : "mobile"),
};
